import React, { Component, PropTypes } from 'react';

import './BookingItem.css';

export default class BookingItem extends Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        value: PropTypes.string,
        extraCssClasses: PropTypes.string,
    }

    render() {
        const display = this.props.value || this.props.children ? `table-cell` : `none`;
        const valueJsx = this.props.value ? <h2>{this.props.value}</h2> : null;

        return (
            <div>
                <section className={`booking-item ${this.props.extraCssClasses}`} style={{ display }}>
                    <h3>{this.props.title}</h3>
                    {this.props.children}
                    {valueJsx}
                </section>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Booking/BookingItem.jsx